<template>
	<div class="toolbar flex align-center justify-space-between">
		<div class="box-left box grow flex">
			<button @click="toggleSidebar" v-if="menuBurger !== 'right'" class="toggle-sidebar card-base card-shadow--small">
				<i class="mdi mdi-menu"></i>
			</button>

			<!-- <search class="hidden-xs-only"></search> -->
		</div>
		<!-- <div class="time">
			<i class="mdi mdi-calendar-clock"></i> {{ formattedDate }} {{ formattedTime }}
		</div> -->
		<!-- <clock timezone="ASIA/JAKARTA" timeFormat="HH:mm.ss" dateFormat="DD.MM.YYYY" /> -->
		<div class="box-right flex align-center pl-10">
			<button class="fullscreen-button" @click="toggleFullscreen">
				<i class="mdi mdi-fullscreen" v-if="!fullscreen"></i>
				<i class="mdi mdi-fullscreen-exit" v-if="fullscreen"></i>
			</button>
			<!--
			<el-popover ref="popover" placement="bottom" :width="popoverWidth" trigger="click">
				<notification-box></notification-box>
			</el-popover>
			<el-badge :is-dot="true" class="notification-icon-badge">
				<el-button v-popover:popover icon="mdi mdi-bell" class="notification-icon"></el-button>
			</el-badge>
			-->
			<span class="username">{{ capitalizeFirstLetter(user.name) }}</span>
			<el-dropdown trigger="hover" @command="onCommand">
				<span class="el-dropdown-link align-vertical-middle">
					<img src="../assets/images/user_default.png" class="avatar" alt="avatar">
				</span>
				<el-dropdown-menu slot="dropdown">
					<!-- <el-dropdown-item command="/user-management"><i class="mdi mdi-settings mr-10"></i> {{ $t("menu.usermanagement") }}</el-dropdown-item> -->
					<el-dropdown-item command="/change-password">
					<i class="mdi mdi-settings mr-10"></i>
						<el-button type="text" command="/change-password">
						 {{ $t("menu.change_password") }}
						</el-button>
					 </el-dropdown-item>
					<!-- <el-dropdown-item command="/logout"><i class="mdi mdi-logout mr-10"></i> {{ $t("menu.logout") }}</el-dropdown-item> -->
					<el-dropdown-item command="/logout">
						<i class="mdi mdi-logout mr-10"></i>
						<el-button type="text" @click="logout">
							Logout
						</el-button>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<button @click="toggleSidebar" v-if="menuBurger === 'right'" class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small">
				<i class="mdi mdi-menu"></i>
			</button>
		</div>
	</div>
</template>

<script>
import NotificationBox from '@/components/NotificationBox'
import Search from '@/components/Search'
import store from '@/store'
import config from '@/config'
const axios = require('axios')
import api from '@/networkClient'
import { Clock } from 'aheenam-dashboard-clock'
import moment from 'moment-timezone'

export default {
	name: 'Toolbar',
	props: {
		menuBurger: {
			type: String
		},
    timezone: {
      type: String,
      default: 'Asia/Jakarta'
    },
    dateFormat: {
      type: String,
      default: 'dddd, DD/MM/YYYY'
    },
    timeFormat: {
      type: String,
      default: 'HH:mm:ss'
    }
  },
	// props: [
	// 	'menuBurger',
	// ],
	data() {
		return {
	    dateTime: moment().tz(this.timezone),
			popoverWidth: 300,
			fullscreen: false,
			lang: 'us',
			user: {
				name: store.getters.userName,
				company: store.getters.companyName
			},
			email:store.getters.email,
			token:store.getters.token
		}
	},
	computed: {
    formattedDate () {
      return this.dateTime.format(this.dateFormat)
    },
    formattedTime () {
      return this.dateTime.format(this.timeFormat)
    }
  },
  created() {
    this.dateTime = moment.tz(this.timezone)
    this.tick()
  },
	methods: {
		tick() {
      setInterval(() => {
        this.dateTime = moment().tz(this.timezone)
      }, 1000)
    },
		logout(){
			api({
				method:'post',
				url:config.baseApi+'auth/logout',
				headers:{
					'Content-Type':'application/json'
				},
			}).then(response => {
				
			}).catch(error => {
				// console.log('Error',errors)
			})
			this.$router.onCommand('/logout')
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		onCommandLang(lang) {
			if(lang.charAt(0) === '/')
				this.onCommand(lang)
			else
				this.lang = lang
		},
		onCommand(path) {
			this.$router.push(path)
		},
		go(url){
			this.$router.push(url)
		},
		toggleSidebar() {
			this.$emit('toggle-sidebar')
		},
		resizePopoverWidth() {
			if(window.innerWidth <= 768) {
				this.popoverWidth = 250
			} else {
				this.popoverWidth = 300
			}
		},
		toggleFullscreen() {
			this.$fullscreen.toggle(document.querySelector('body'), {
				wrap: false,
				callback: () => {this.fullscreen = this.$fullscreen.getState()}
			})
		},
		go(url){
			this.$router.push(url)
		}
	},
	components: {
		NotificationBox,
		Search,
		Clock
	},
	mounted() {
		this.fullscreen = this.$fullscreen.getState()
		this.resizePopoverWidth();
		window.addEventListener('resize', this.resizePopoverWidth);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizePopoverWidth);
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';

.clock {
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 100%;
}

.timezone {
  display: block;
  font-size: 0.5em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-top: 3em;
}

.date {
  font-size: 1em;
  font-family: monospace;
  text-transform: uppercase;
  margin-bottom: 0.5em;
}

.time {
  font-size: 1.2em;
  font-family: monospace;
}

.toolbar {
	width: 100%;
	height: 100%;
	padding: 10px 50px;
	box-sizing: border-box;
	background-color: $background-color;

	.username {
		margin-left: 20px;
		font-weight: bold;
		color: $text-color-accent;
		// @include text-bordered-shadow();

		a {
			color: $text-color;
			text-decoration: none;

			&:hover {
				color: $text-color-accent;
			}
		}
	}

	.avatar {
		border-radius: 50%;
		width: 35px;
		height: 35px;
		// border: 1px solid #FFF;
		margin-left: 20px;
		box-sizing: border-box;
		display: block;
		cursor: pointer;
		box-shadow: 0 2px 5px 0 rgba(49,49,93,.1), 0 1px 2px 0 rgba(0,0,0,.08);
		transition: box-shadow .5s;

		&:hover {
			box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08), 0px 2px 7px 0 rgba(0, 0, 0, 0.08);
		}
	}

	.notification-icon {
		font-size: 20px;
		outline: none;
		padding: 0;
		background: transparent;
		border: none;
		margin-left: 20px;
		//color: #aab7c5;
		// color: transparentize($background-color, 0.7);
		color: $background-color;
		// @include text-bordered-shadow();

		&:hover {
			color: $text-color-accent;
		}

		.is-dot {
			border: none;
		}
	}

	.toggle-sidebar {
		border: 1px solid transparent;
		height: 32px;
		min-height: 32px;
		line-height: 32px;
		width: 32px;
		min-width: 32px;
		max-width: 32px;
		box-sizing: border-box;
		text-align: center;
		margin: 0;
		outline: none;
		margin-right: 5px;
		font-size: 24px;
		padding: 0;
		cursor: pointer;
		display: inline-block;
		color: $text-color;
		background: white;
		display: none;
		opacity: 0;
		transition: all .5s;

		&__right {
			margin-right: 0px;
			margin-left: 5px;
		}

		&:hover, &:focus, &:active {
			color: $text-color-accent;
			border-color: $text-color-accent;
		}
	}

	.fullscreen-button {
		font-size: 24px;
		cursor: pointer;
		outline: none;
		padding: 0;
		background: transparent;
		border: none;
		margin-left: 20px;
		//color: #aab7c5;
		// color: transparentize($text-color, 0.7);
		color: $background-color;
		// @include text-bordered-shadow();

		&:hover {
			color: $text-color-accent;
		}
	}

	.el-dropdown {
		.flag-icon {
			box-shadow: 0 2px 5px 0 rgba(49,49,93,.1), 0 1px 2px 0 rgba(0,0,0,.08);
			cursor: pointer;
			border: 1px solid lighten($background-color, 20%);
			background-color: lighten($background-color, 20%);
		}
	}
}

@media (max-width: 650px) {
	.toolbar {
		.username {
			display: none;
		}
	}
}

@media (max-width: 768px) {
	.toolbar {
		padding: 0 10px;

		.toggle-sidebar {
			display: block;
			opacity: 1;
		}

		.fullscreen-button {
			display: none;
		}
	}
}
</style>


<style lang="scss">
sup.is-dot{
	border:none;
}
</style>
